import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { API } from '../../../request/api';

const useCampaign = () => {
  const Login = useSelector((state) => state.Login);

  const [Gif, setGif] = useState('');
  const [GifBackColor, setGifBackColor] = useState('');
  const [GifUrlData, setGifUrlData] = useState(null);

  // const getSiteHeader = () => {
  //   API.get
  //     .config("site_header_back_color")
  //     .then((response) => {
  //       if (response.success) {
  //         setGifBackColor(response.data["site_header_back_color"]);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  //   API.get
  //     .config("site_header")
  //     .then((response) => {
  //       if (response.success) {
  //         setGif(response.data["site_header"]);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  const getSliderHeader = () => {
    API.get
      .headerLayout(Login.city_id, 'header')
      .then((response) => {
        if (response.success) {
          setGif(response.data[0].image);
          setGifBackColor(response.data[0]?.background_color_left);
          setGifUrlData({
            is_external_url: response.data[0]?.external_url,
            is_active: response.data[0]?.counter_is_active,
            url: response.data[0]?.url,
            product: response.data[0]?.product,
            started_at: response.data[0]?.started_at,
            ended_at: response.data[0]?.ended_at,
            now: response.data[0]?.now,
            position: response.data[0]?.design?.position,
            code: response.data[0]?.design?.code,
            color: response.data[0]?.design?.color,
            background_color_left: response.data[0]?.background_color_left,
            background_color_right: response.data[0]?.background_color_right,
            image: response.data[0]?.image
          });
        }
        return response;
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Error : ', error);
      });
  };

  useEffect(() => {
    getSliderHeader();
    // eslint-disable-next-line
  }, []);

  return { Gif, GifBackColor, GifUrlData };
};

export default useCampaign;
